<template>
  <div class="website-detail">
    <el-row class="website-head">
      <el-col :span="10">公司：{{ websiteInfo.custName | nullShow }}</el-col>
      <el-col :span="10">语言：{{ websiteInfo.languageStrs | nullShow }}</el-col>
      <el-col
        :span="10"
        class="head-box"
      >订单号：{{ websiteInfo.orderCode | nullShow }}</el-col>
      <el-col
        :span="10"
        class="head-box"
      >上线统计：{{ websiteInfo.langCount | nullShow }}</el-col>
    </el-row>
    <data-list
      :data="data"
      :columns="column"
      :page="page"
      :page-size="page.pageSize"
      :loading="loading"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
    ></data-list>
    <el-dialog
      :visible.sync="dialogVisable"
      @close="close"
      :title="website.bindId ? '编辑域名节点' : '新增域名节点'"
      close-on-click-modal
      width="800px"
    >
      <el-form
        :model="website"
        :rules="rules"
        ref="website"
        class="demo-form-inline"
        label-width="130px"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item
              label="网站名称"
              :span="12"
              prop="websiteId"
            >
              <span v-if="row.status != 0">{{ website.webName }}</span>
              <el-select
                filterable
                v-else
                remote
                v-model="website.websiteId"
                :remote-method="getSiteList"
                placeholder="未绑定节点服务器"
              >
                <el-option
                  v-for="item in websiteList"
                  :key="item.id"
                  :label="item.webName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="服务器名称"
              :span="12"
              prop="nodeId"
            >
              <!--<span v-if="website.bindId">{{website.addressName}}</span>-->
              <el-select
                v-model="website.nodeId"
                placeholder="未绑定节点服务器"
              >
                <el-option
                  v-for="item in serverList"
                  :key="item.code"
                  :label="item.addressName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="是否我司域名"
              prop="companyDomainFlag"
            >
              <el-radio-group v-model="website.companyDomainFlag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="是否开启cdn加速"
              prop="cdnFlag"
            >
              <el-radio-group v-model="website.cdnFlag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="是否开启智能dns"
              prop="dnsFlag"
            >
              <el-radio-group v-model="website.dnsFlag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- 访问域名 -->
          <el-col :span="20">
            <el-form-item
              label="访问域名"
              prop="cdnFlag"
            >
              <el-input
                v-model="website.domainName"
                placeholder="访问域名"
                style="80%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="域名"
              :key="domain.key"
              v-for="domain in dynamicValidateForm.domains"
              :rules="{
                required: true,
                message: '请输入域名',
                trigger: 'blur'
              }"
            >
              <el-col :span="5">
                <el-form-item prop="prefix">
                  <el-input
                    v-model="domain.prefix"
                    placeholder="主机记录"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">.</el-col>
              <el-col :span="18">
                <el-form-item prop="domainName">
                  <el-autocomplete
                    v-if="website.companyDomainFlag == 1"
                    v-model="domain.domainName"
                    value-key="domainName"
                    :fetch-suggestions="getDomain()"
                    placeholder="域名"
                    style="width: 80%"
                  ></el-autocomplete>
                  <el-input
                    v-else
                    v-model="domain.domainName"
                    placeholder="域名"
                    style="width: 80%"
                  ></el-input>
                  <span
                    @click.prevent="removeDomain(domain)"
                    style="margin-left:10px;cursor: pointer;"
                  >x</span>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              label="是否安装ssl证书"
              prop="sslFlag"
            >
              <el-radio-group v-model="website.sslFlag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            :span="20"
            v-if="website.sslFlag == 1"
          >
            <el-form-item
              label="证书上传类型"
              prop="uploadType"
            >
              <el-radio-group v-model="website.uploadType">
                <!-- <el-radio :label="1">压缩包</el-radio> -->
                <el-radio :label="2">文本</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-if="website.sslFlag == 1 && website.uploadType == 1"
          >
            <el-form-item label="上传证书：">
              <el-upload
                class="upload-demo"
                drag
                :limit="1"
                :action="action"
                accept=".RAR,.ZIP,.RAR4"
                :on-success="uploadSuccess"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  {{
                    website.fileName
                      ? "已有上传证书，或"
                      : "将文件拖到此处，或"
                  }}<em>{{ website.fileName ? "重新上传" : "点击上传" }}</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col
            :span="20"
            v-if="website.uploadType == 1"
          >
            <el-form-item
              label="证书类型"
              prop="sslType"
            >
              <el-radio-group v-model="website.sslType">
                <el-radio :label="0">阿里云</el-radio>
                <el-radio :label="3">腾讯云</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            :span="20"
            v-if="website.sslFlag == 1 && website.uploadType == 2"
          >
            <el-form-item
              label="证书公钥"
              prop="sslPublic"
            >
              <el-input
                size="small"
                type="textarea"
                placeholder="----BEGIN CERTIFICATE-----"
                v-model="website.sslPublic"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="20"
            v-if="website.sslFlag == 1 && website.uploadType == 2"
          >
            <el-form-item
              label="证书私钥"
              prop="sslKey"
            >
              <el-input
                size="small"
                type="textarea"
                placeholder="----BEGIN RSA PRIVATE KEY-----"
                v-model="website.sslKey"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="20"
            v-if="website.sslFlag == 1 && website.uploadType == 2"
          >
            <el-form-item
              label="证书链"
              prop="sslChain"
            >
              <el-input
                size="small"
                type="textarea"
                placeholder="----BEGIN CERTIFICATE-----"
                v-model="website.sslChain"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="24"
            v-if="website.sslFlag == 1 && website.uploadType == 2"
            class="ssl-hint"
          >
            <div>1、请下载Apache环境证书文件。</div>
            <div>
              2、阿里证书包含证书私钥文件215031781020889.key、证书公钥文件public.pem、证书链文件chain.pem。
            </div>
            <div>
              3、腾讯证书包含证书私钥文件3_www.domain.com.key、证书公钥文件2_www.domain.com_cert.crt、证书链文件1_root_bundle.crt。
            </div>
            <div>4、请将文件内容拷至对应输入框中。</div>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="addBind"
        >确认</el-button>
        <el-button @click="addDomain">新增域名</el-button>
        <el-button @click="dialogVisable = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="uploadDialog"
      @close="confirmCloseUpload"
      :close-on-click-modal="clickClose"
      title="上传进度"
      width="600px"
    >
      <div style="margin: 0 auto; text-align: center">
        <el-progress
          type="circle"
          :percentage="getPercent"
          :status="uploadStatus"
        ></el-progress>
        <h4>总文件数：{{ getFile }}</h4>
        <el-button
          type="primary"
          @click="online(row)"
          v-if="uploadStatus == 'success'"
        >立即上线</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/backend/apiConfig/apiConfig'
import website from '@/backend/services/website/website.js'
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue'
import listPageCreate from '@/mixins/listPageCreate'
import skyUploadImg from '@/components/iglobalwin/formComponents/sky-uploadimg'
import jumpLink from '@/components/website/jumpLink'
import { formatElementPerc } from '@/common/util'
import editText from '@/components/tools/edit_text'
import {
  addCdnDomain,
  refreshCdnDomain,
  refreshCdnStatus
} from '@/backend/services/website/website'
const list = listPageCreate({
  searchConfig: {
    api: api.website.websitelist,
    method: 'POST'
  },
  getQuery(obj, that) {
    return _.assign(obj, { orderId: that.$route.query.orderId })
  }
})
export default {
  components: {
    formCombination,
    skyUploadImg
  },
  name: 'websiteDetail',
  mixins: [list],
  data() {
    const that = this
    const column = [
      {
        label: '',
        width: 20
      },

      {
        label: '网站名称',
        bind: 'webName'
      },
      {
        label: '语言',
        bind: 'dicCodeName'
      },
      {
        label: '平台',
        bind: 'websiteTypeName'
      },
      {
        label: '域名节点',
        type: 'custom',
        componentName: jumpLink,
        bind: 'domain'
      },
      {
        label: '订单主域名',
        type: 'custom',
        componentName: jumpLink,
        bind: 'domainName'
      },
      {
        label: '网站上线时间',
        type: 'custInfo',
        text: [
          {
            bind: 'yybCreateTimeStr'
          }
        ],
        minWidth: 100
      },
      {
        label: '最后同步时间',
        bind: 'synchroTime',
        type: 'percentage',
        dataStyle(val, row) {
          return row.sitePlatform === 1 ? val || '-' : '-'
        }
      },
      {
        label: '操作人',
        bind: 'yybCreater'
      },
      {
        label: '状态',
        bind: 'statusName'
      },
      {
        label: '预览网站',
        bind: 'websitePreviewUrl',
        type: 'custom',
        width: 180,
        componentName: editText,
        config: {
          componentType: 'sky-input',
          placeholder: '请输入网址',
          toolContent: '我是内容'
        },
        showButton() {
          return true
        },
        async triggerEvent(row, data, cb) {
          if (!data) {
            that.$message.warning('请输入内容')
            return false
          }
          let res = await website.compileWebsiteUrl({
            id: row.bindId,
            url: data
          })
          if (res.status == '204') {
            that.query()
            cb()
          } else {
            that.$message.warning('操作失败')
            cb()
          }
        },
        defaultClick(row) {
          let url = row.websitePreviewUrl
          if (url && url.indexOf('http' || 'https') != -1) {
            window.open(`${row.websitePreviewUrl}`, '_blank')
          } else {
            window.open(`//${row.websitePreviewUrl}`, '_blank')
          }
        }
      },
      {
        label: '操作',
        type: 'btnClick',
        align: 'center',
        width: 400,
        bind(row) {
          if (row.sitePlatform == 2) {
            return []
          }
          let obj = that.statusList.find(item => item.status === row.status)
          let list = obj.btnList.slice()
          if (row.status == 6 && row.cdnFlag === 1) {
            //0:初始化;1:创建CDN加速域名中;2:创建CDN加速域名成功;3:创建CDN加速域名失败;4:设置host回源中;5:设置host回源成功;6:设置host回源失败
            let param = {
              bindId: row.bindId,
              nodeId: row.bindNodeId,
              websiteId: row.bindWebsiteId
            }
            let cdnTypeList = [
              {
                status: 0,
                btn: {
                  text: '创建cdn',
                  trigger: that.getCdnFn(addCdnDomain, param, '创建cdn加速')
                }
              },
              {
                status: 1,
                btn: {
                  text: '刷新cdn',
                  trigger: that.getCdnFn(refreshCdnStatus, param, '刷新cdn加速')
                }
              },
              {
                status: 2,
                btn: {
                  text: '刷新cdn',
                  trigger: that.getCdnFn(refreshCdnStatus, param, '刷新cdn加速')
                }
              },
              {
                status: 3,
                btn: {
                  text: '重新创建cdn',
                  trigger: that.getCdnFn(addCdnDomain, param, '重新创建cdn')
                }
              },
              {
                status: 5,
                btn: {
                  text: '修改cdn',
                  trigger: that.getCdnFn(addCdnDomain, param, '修改cdn')
                }
              },
              {
                status: 6,
                btn: {
                  text: '设置回源',
                  trigger: that.getCdnFn(refreshCdnStatus, param, '设置回源')
                }
              }
            ]
            let cdnObj = cdnTypeList.find(item => item.status == row.cdnType)
            cdnObj && list.push(cdnObj.btn)
            if (row.cdnType == 5) {
              list.push({
                text: '刷新缓存',
                trigger: that.getCdnFn(refreshCdnDomain, param, '刷新缓存')
              })
            }
          }
          return list || []
        }
      }
    ]
    return {
      action: api.website.fileUpload,
      column: column,
      websiteType: 0,
      websiteList: [],
      websiteInfo: '',
      orderid: '',
      dialogVisable: false,
      website: {
        domainInfoList: [],
        nodeId: '',
        companyDomainFlag: 1, //是否我司域名
        sslFlag: 1, //是否安装ssl证书
        uploadType: 2,
        //上传图片
        sslType: 0,
        sslPublic: '',
        sslKey: '',
        sslChain: ''
      },
      rules: {
        nodeId: [
          {
            required: true,
            message: '请选择服务器',
            trigger: 'change'
          }
        ],
        companyDomainFlag: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ],
        sslFlag: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ]
      },
      userInfo: {},
      serverList: [],
      baseInfo: {},
      uploadDialog: false,
      clickClose: false,
      photoList: [],
      isTrue: true,
      progress: {},
      length: 0,
      row: {},
      uploadStatus: null,
      timer: null,
      dynamicValidateForm: {
        //动态新增域名
        domains: [
          {
            prefix: '',
            domainName: ''
          }
        ]
      },
      statusList: [
        {
          status: 0,
          statusName: '待配置',
          btnList: [
            {
              text: '配置',
              trigger: that.editSite
            }
          ]
        },
        {
          status: 1,
          statusName: '待发布',
          btnList: [
            {
              text: '发布',
              trigger: that.release
            },
            {
              text: '配置',
              trigger: that.editSite
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        },
        {
          status: 2,
          statusName: '发布中',
          btnList: [
            {
              text: '查看进度',
              trigger: that.showUploadProgress
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        },
        {
          status: 3,
          statusName: '已发布',
          btnList: [
            {
              text: '上线',
              trigger: that.online
            },
            {
              text: '配置',
              trigger: that.editSite
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        },
        {
          status: 4,
          statusName: '发布失败',
          btnList: [
            {
              text: '发布',
              trigger: that.release
            },
            {
              text: '配置',
              trigger: that.editSite
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        },
        {
          status: 5,
          statusName: '上线中',
          btnList: [
            {
              text: '配置',
              trigger: that.editSite
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        },
        {
          status: 6,
          statusName: '已上线',
          btnList: [
            {
              text: '下线',
              trigger: that.offline
            },
            {
              text: '配置',
              trigger: that.editSite
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        },
        {
          status: 7,
          statusName: '上线失败',
          btnList: [
            {
              text: '重新上线',
              trigger: that.online
            },
            {
              text: '配置',
              trigger: that.editSite
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        },
        {
          status: 8,
          statusName: '已下线',
          btnList: [
            {
              text: '重新上线',
              trigger: that.online
            },
            {
              text: '配置',
              trigger: that.editSite
            },
            {
              text: '解绑',
              trigger: that.unbind
            }
          ]
        }
      ]
      //loading:false
    }
  },
  computed: {
    getPercent: function() {
      return formatElementPerc(
        this.progress.serviceFileSize
          ? (this.progress.serviceFileSize / this.progress.localFileSize) * 100
          : 0
      )
    },
    getFile: function() {
      return this.progress.serviceFileNum
        ? `${this.progress.serviceFileNum}/${this.progress.localFileNum}`
        : '-'
    }
  },
  watch: {
    'website.websiteId': function() {
      this.getUnBindList()
    },
    getPercent(val) {
      if (val == 100 || val > 100) {
        clearInterval(this.timer)
        this.confirmCloseUpload()
        this.uploadStatus = 'success'
      }
    }
  },
  methods: {
    getCdnFn(service, param, msg) {
      return () => {
        this.$confirm(`是否确认${msg}`).then(async () => {
          await service(param)
          this.$message.success('成功')
          this.query()
        })
      }
    },
    getSiteList(key) {
      website
        .getSiteList({
          webName: key,
          websiteType: this.websiteType
        })
        .then(val => {
          this.websiteList = val.data
        })
    },
    uploadSuccess(res) {
      this.website.fileName = res.result.data
    },
    editSite({ bindId, websiteType, status }) {
      this.row.status = status
      this.websiteType = websiteType
      website.getSiteDetail(bindId).then(val => {
        if (val.data) {
          this.website = val.data
          this.dynamicValidateForm.domains = this.website.domainInfoList
          this.photoList = [{ url: this.website.fileName }]
          this.dialogVisable = true
        }
      })
    },
    getUnBindList() {
      return website
        .getNodeList({
          bindFlag: 0,
          websiteId: this.website.nodeId,
          displayLength: 200,
          displayStart: 1
        })
        .then(val => {
          if (val.data) {
            this.serverList = val.data.data
          }
        })
    },
    showUploadProgress(row) {
      const that = this
      that.row = row
      that.uploadDialog = true

      that.timer = setInterval(async () => {
        await that.getProgress()
      }, 1000)
    },
    confirmCloseUpload() {
      this.uploadStatus = null
      this.query()
    },
    async getProgress() {
      const that = this
      const row = that.row
      let obj = {
        bindId: row.bindId,
        nodeId: row.bindNodeId,
        websiteId: row.bindWebsiteId,
        ...this.baseInfo
      }
      let val = await website.getUploadInfo(obj)
      if (val.data) {
        this.progress = val.data
        if (val.data.status == 1) {
          this.uploadStatus = 'success'
          this.timer && clearInterval(this.timer)
          this.query()
        }
      }
    },
    addBind() {
      const that = this
      that.website.domainInfoList = that.dynamicValidateForm.domains
      if (
        (that.website.sslFlag == 1 &&
          that.website.uploadType == 1 &&
          !that.website.fileName) ||
        (that.website.uploadType == 1 && that.website.fileName == '')
      ) {
        that.$message.warning('请上传文件')
        return
      }
      this.$refs.website.validate(valid => {
        if (valid) {
          let service = website.bindNode
          let msg = '新增'
          if (that.website.bindId) {
            service = website.updateDomain
            msg = '编辑'
          }
          let obj = {
            ...that.website,
            ...that.baseInfo
          }
          if (
            that.website.domainService == 1 &&
            that.websiteList.length !== 0
          ) {
            let currentObject = that.websiteList.find(
              item => item.id === that.website.websiteId
            )
            obj.domainInfoList = obj.domainInfoList.map(item => {
              return {
                ...item,
                prefix: item.prefix.replace(
                  'XXX',
                  currentObject ? currentObject.uid : ''
                )
              }
            })
          }
          service(obj).then(val => {
            if (val.data) {
              that.$message.success(msg + '节点成功!')
              that.getUnBindList()
              that.$refs.website.resetFields()
              that.dialogVisable = false
              that.website = {}
              that.query()

              // that.website = {
              // 	domainName: '',
              // 	nodeId: ''
              // }
            } else {
              that.$message.error(msg + '节点失败!')
            }
          })
        }
      })
    },
    offline(row) {
      this.unbind(row, this, 0)
    },
    unbind({ bindId }, self, type = 1) {
      const that = this
      let msg = type == 1 ? '解绑' : '下线'
      that.confirmFunc({
        msg: `确定${msg}该节点？`,
        method: 'get',
        service: website.unbindNode,
        params: {
          id: bindId,
          type: type
        },
        success: function(val) {
          if (val.data) {
            that.$message.success(msg + '成功!')
            that.query()
            that.getUnBindList()
          } else {
            that.$message.error(msg + '失败!')
          }
        },
        fail: function() {}
      })
    },
    release(row) {
      const that = this
      that.row = row
      let msg =
        row.updateFlag == 1 ? '确定发布？' : '没有任何更新,确定继续发布？'
      that.confirmFunc({
        msg: msg,
        service: website.upload,
        params: {
          bindId: row.bindId,
          nodeId: row.bindNodeId,
          websiteId: row.bindWebsiteId,
          ...that.baseInfo
        },
        success(val) {
          if (val.data) {
            that.$message.success('开始发布...')
            that.uploadDialog = false
            that.query()
            that.showUploadProgress(row)
            // that.getUnBindList()
          } else {
            that.$message.error('发布失败!')
          }
        },
        fail() {}
      })
    },
    online(row) {
      const that = this
      that.uploadDialog = false
      that.confirmFunc({
        msg: '确定上线？',
        service: website.release,
        params: {
          bindId: row.bindId,
          nodeId: row.bindNodeId,
          websiteId: row.bindWebsiteId,
          ...that.baseInfo
        },
        success: function(val) {
          if (val.data) {
            that.$message.success('操作成功...')
            that.query()
            // that.getUnBindList()
          } else {
            that.$message.error('发布失败!')
          }
        },
        fail: function() {}
      })
    },
    confirmFunc(options) {
      this.$confirm(options.msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          options
            .service(options.params)
            .then(val => {
              options.success(val)
            })
            .catch(err => {
              options.fail && options.fail(err)
            })
        })
        .catch(err => {
          options.fail && options.fail(err)
        })
    },
    close() {
      this.dynamicValidateForm.domains = [
        {
          prefix: '',
          domainName: ''
        }
      ]
      this.website = {}
      this.photoList = []
      this.$refs.website.resetFields()
    },
    addDomain() {
      //新增域名
      this.dynamicValidateForm.domains.push({
        prefix: '',
        domainName: ''
        //key: Date.now()
      })
    },
    removeDomain(item) {
      //删除域名
      let data = this.dynamicValidateForm
      if (this.dynamicValidateForm) {
        var index = data.domains && data.domains.indexOf(item)
      }
      if (index >= 1) {
        data.domains && data.domains.splice(index, 1)
      }
    },
    getDomain() {
      return (str, cb) => {
        if (str) {
          website.getAliDomainList(str).then(val => {
            if (val.data) {
              cb(val.data)
            }
          })
        } else {
          cb([])
        }
      }
    },
    async getOrderwebsiteinfo(val) {
      let datas = await website.getOrderwebsiteinfo({ orderId: val })
      this.websiteInfo = datas.data
    }
  },
  mounted() {
    this.orderid = this.$route.query.orderId
    this.getOrderwebsiteinfo(this.orderid)
    this.query()
  },
  filters: {
    nullShow(value) {
      return value == undefined || value == null ? '-' : value
    }
  }
}
</script>

<style scoped lang="scss">
.website-head {
  width: 100%;
  background: #ffffff;
  padding: 20px;
  margin-bottom: 10px;
}

.head-box {
  margin-top: 10px;
}

.ssl-hint {
  font-size: 12px;
  columns: #d4d4d4;
  line-height: 1.5em;
  div {
    margin: 5px 0;
    margin-left: 8px;
  }
}
</style>
